import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useLocation, Redirect } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { Formik, Form } from 'formik';
import routes from 'constants/routes';
import * as config from 'config';
import { ShareBlock, TreatmentCostInput } from '@futurefamily/ef-components';
import DownpaymentSlider from './DownpaymentSlider';
import { formatCurrency } from '@futurefamily/ef-utils';
import { useForm } from './hooks';
import TermSelector from './TermSelector';
import PaymentOptions from './PaymentOptions';

const Wrapper = styled(Form)`
  display: flex;
  flex-direction: column;

  --option-card-size: calc(260px);
  --option-gutter-x: 20px;
`;

const Section = styled.div`
  padding: 20px 0;
`;

function validate (values) {
  const errors = {};

  if (values.cost < config.LOAN_MINIMUM || values.cost > config.LOAN_MAXIMUM) {
    const min = formatCurrency(config.LOAN_MINIMUM);
    const max = formatCurrency(config.LOAN_MAXIMUM);
    errors.cost = `Please enter an amount between $${min} and $${max}`;
  }

  return errors;
}

function Calculator ({ className }) {
  const location = useLocation();
  const isMobile = useMediaQuery({
    query: '(max-width: 767px)'
  });
  const { initialValues, onSubmit } = useForm(config.LOAN_MINIMUM, config.DEFAULT_TERM);
  const query = new URLSearchParams(location.search);

  if (!query.has('cost')) {
    return <Redirect to={routes.treatmentOptions} />;
  }

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit} validate={validate}>
      <Wrapper role="form" className={className}>
        <div className="container">
          {!query.has('cost') && (
            <TreatmentCostInput loanMinimum={config.LOAN_MINIMUM} loanMaximum={config.LOAN_MAXIMUM} />
          )}

          <PaymentOptions />
        </div>

        <Section>
          <div className="container">
            <DownpaymentSlider className="mb-5" />
            <TermSelector className="mb-4 mb-md-0" />

            {isMobile && <ShareBlock basename={config.BASENAME} />}
          </div>
        </Section>
      </Wrapper>
    </Formik>
  );
}

Calculator.propTypes = {
  className: PropTypes.string
};

export default Calculator;
